export default "__VITE_ASSET__DQW1AMKf__"